import ServicePage from "../Common/ServicePage";

// Switch Board Install specific services
const switchBoardServices = [
  { 
    id: 1, 
    name: 'Basic Switch Board Install', 
    provider: 'SwitchPro Experts', 
    image: 'https://placehold.co/600x400?text=Basic+Switchboard', 
    rating: 4.75, 
    reviews: 600, 
    price: 400, 
    category: 'Basic Installation' 
  },
  { 
    id: 2, 
    name: 'Premium Switch Board Install', 
    provider: 'EliteSwitch Solutions', 
    image: 'https://placehold.co/600x400?text=Premium+Switchboard', 
    rating: 4.82, 
    reviews: 550, 
    price: 650, 
    category: 'Premium Installation' 
  },
  { 
    id: 3, 
    name: 'Switch Replacement Service', 
    provider: 'SwitchFix Professionals', 
    image: 'https://placehold.co/600x400?text=Switch+Replacement', 
    rating: 4.78, 
    reviews: 450, 
    price: 100, 
    category: 'Replacement' 
  },
  { 
    id: 4, 
    name: 'Socket Replacement Service', 
    provider: 'SocketCare Specialists', 
    image: 'https://placehold.co/600x400?text=Socket+Replacement', 
    rating: 4.80, 
    reviews: 500, 
    price: 150, 
    category: 'Replacement' 
  },
  { 
    id: 5, 
    name: 'Modular Switch Board Installation', 
    provider: 'ModularSwitch Experts', 
    image: 'https://placehold.co/600x400?text=Modular+Switchboard', 
    rating: 4.85, 
    reviews: 700, 
    price: 800, 
    category: 'Modular Installation' 
  },
  { 
    id: 6, 
    name: 'Dimmer Switch Installation', 
    provider: 'DimLight Professionals', 
    image: 'https://placehold.co/600x400?text=Dimmer+Switch', 
    rating: 4.79, 
    reviews: 350, 
    price: 300, 
    category: 'Specialty Installation' 
  },
  { 
    id: 7, 
    name: 'Multiple Socket Board Install', 
    provider: 'MultiSocket Solutions', 
    image: 'https://placehold.co/600x400?text=Multi+Socket', 
    rating: 4.76, 
    reviews: 400, 
    price: 350, 
    category: 'Multi Socket' 
  },
  { 
    id: 8, 
    name: 'Circuit Breaker Integration', 
    provider: 'CircuitSafe Services', 
    image: 'https://placehold.co/600x400?text=Circuit+Breaker', 
    rating: 4.83, 
    reviews: 300, 
    price: 500, 
    category: 'Safety Installation' 
  },
  { 
    id: 9, 
    name: 'USB Socket Installation', 
    provider: 'TechSocket Experts', 
    image: 'https://placehold.co/600x400?text=USB+Socket', 
    rating: 4.88, 
    reviews: 250, 
    price: 200, 
    category: 'Modern Installation' 
  },
  { 
    id: 10, 
    name: 'Switch Board Upgrade Service', 
    provider: 'UpgradePro Professionals', 
    image: 'https://placehold.co/600x400?text=Board+Upgrade', 
    rating: 4.81, 
    reviews: 380, 
    price: 600, 
    category: 'Upgrade Service' 
  }
];

const switchBoardCategories = ['Basic Installation', 'Premium Installation', 'Modular Installation', 'Replacement', 'Specialty Installation', 'Multi Socket', 'Safety Installation', 'Modern Installation', 'Upgrade Service'];

const packages = [
  { id: 1, title: "Basic Switch Board Install", rating: "4.75 (600 reviews)", price: 400, originalPrice: 500, icon: "🔘" },
  { id: 2, title: "Premium Switch Board Install", rating: "4.82 (550 reviews)", price: 650, originalPrice: 800, icon: "💎" },
];

const miniServices = [
  { id: 101, title: "Switch Replacement", price: 100, icon: "⚡" },
  { id: 102, title: "Socket Replacement", price: 150, icon: "🔌" },
];

export default function SwitchBoardInstall() {
  return (
    <ServicePage
      serviceName="Switch Board Install"
      packages={packages}
      miniServices={miniServices}
      customServices={switchBoardServices}
      customCategories={switchBoardCategories}
      isCustomService={true}
    />
  );
}